import React, { useState, useEffect, useCallback, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import InputField from '../Input';
import Bouton from '../Bouton';
import ListDeroule from '../ListDeroule';
import 'bootstrap/dist/css/bootstrap.min.css';
import SousTitre from '../../SousTitre';
import './form.css';
import Ajout from '../Ajout';
import BilanInter from '../../BilanInter';
import CheckboxChoixUnique from '../checkBox/checkbox';
import InputFieldNb from '../InputNombre/index';
import CheckboxAjout from '../checkBoxAjout/CheckboxAjout';
import AjoutPerso from '../Ajout/index-personne';
import { Button } from '@mui/material';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import CheckboxChoixUnique3 from '../checkBox/checkbox-3';
import InputFieldNbUnique from '../InputNombre/indexUnit';
import AppelAPIPlacement from '../../Api/AppelAPIPlacement';
import { useFormProgress } from '../../FormProgressContext';
import CacheContextPlacement from '../../../components/cachescontext/contextPlacement';

function FormPlacement({ onSubmit }) {
  const { cache, setCache, setCacheCustom } = useContext(CacheContextPlacement);
  const navigate = useNavigate();
  const [valeurInput, setValeurInput] = useState(() => cache.valeurInput || '7');
  const [formSubmitted, setFormSubmitted] = useState(() => cache.formSubmitted || false);
  const [displayBilan, setDisplayBilan] = useState(() => cache.displayBilan || false);
  const [consommationConnue, setConsommationConnue] = useState(() => cache.consommationConnue || false);
  const { formStatus, setFormStatus } = useFormProgress();
  const [placements, setPlacements] = useState(() => cache.placements || [
    {
      banque: 279640000,
      montant: 0,
      nomBanque:"Banque Populaire - Caisse d'Epargne",
      consoPlacement:''
    },
  ]);

  useEffect(() => { window.scrollTo(0, 0); }, []);

  useEffect(() => {
    console.log("Modif placements", placements)
  }, [placements]);

  const handleButtonClick = (event) => {
    event.preventDefault();
    navigate("/bilan");
  };

  const [lancer, setLancer] = useState(false);
  const [apiResponse, setApiResponse] = useState(null);

  const updateApiResponse = (response) => { setApiResponse(response); };

  const handleButtonClickAPI = () => {
    setLancer(true);
    setDisplayBilan(true);
    setFormSubmitted(false);
  };

  const handleDeletePlacement = (index) => {
    setDisplayBilan(false)
    setPlacements((prevPlacements) => {
      const updatedPlacements = [...prevPlacements];
      updatedPlacements.splice(index, 1);
      return updatedPlacements;
    });
  };
  
  const updateConsoPlacement = (index, ConsoPlacementBanque) => {
    setPlacements((prevPlacements) => {
      const newPlacements = [...prevPlacements];
      newPlacements[index] = { ...newPlacements[index], consoPlacement: ConsoPlacementBanque };
      return newPlacements;
    });
  };

  const addPlacement = useCallback(() => {
    setDisplayBilan(false)
    setPlacements((prevPlacements) => [
      ...prevPlacements,
      {
        banque: 279640000,
        montant: 0,
        nomBanque:"Banque Populaire - Caisse d'Epargne",
        consoPlacement:''
      },
    ]);
  }, []);

  useEffect(() => {
    setCache(prevCache => ({
      ...prevCache,
      valeurInput,
      formSubmitted,
      displayBilan,
      consommationConnue,
      placements,
    }));
    setCacheCustom()
  }, [valeurInput, formSubmitted, displayBilan, consommationConnue, placements]);

  const handleSubmit = (event) => {
    event.preventDefault();
    setFormSubmitted(true);
    setDisplayBilan(true);
    setFormStatus({
      ...formStatus,
      placement: 'fini',
    });
  }

  useEffect(() => {
    setFormStatus({
        ...formStatus,
        placement: 'en cours',
    });
  }, []);

  useEffect(() => {
    if (displayBilan) {
      setFormStatus({
        ...formStatus,
        placement: 'fini',
      });
    } else if (formSubmitted) {
      setFormStatus({
        ...formStatus,
        placement: 'en cours',
      });
    }
  }, [formSubmitted, displayBilan]);

  const handleChangePlacement = useCallback((index, field, value, nameBanque) => {
    setDisplayBilan(false)
    setPlacements((prevPlacements) => {
      const updatedPlacements = [...prevPlacements];
      const placement = updatedPlacements[index];
      if (placement) {
        placement[field] = value;
        if(nameBanque !== 0){
          placement["nomBanque"] = nameBanque
        }
      }
      return updatedPlacements;
    });
  }, []);

  return (
    <form onSubmit={handleSubmit} className="page-placement-form">

      <div>
        <div className="row">
          <div className="col-12">
            {placements.map((placement, index) => (
              <div className="duplique" key={index}>
                
                <div className="row col-12">
                  <div className="SousTitre">
                    <DeleteOutlinedIcon sx={{ color : "#024C4A"}} className="Icon" onClick={() => handleDeletePlacement(index)} />
                    <div className="h61">Placement {index + 1}</div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-6" style={{marginTop:"10px"}}>
                    <ListDeroule
                      titre="Banque"
                      text={"Banque Populaire - Caisse d'Epargne"}
                      value={placement.banque}
                      onChange={(value) => {
                        let convertedValue;
                        switch (value) {
                          case "Banque Populaire - Caisse d'Epargne": convertedValue = 279640000; break;
                          case "Caisse d'Epargne": convertedValue = 279640001; break;
                          case "La Banque Postale": convertedValue = 279640002; break;
                          case "Société Générale": convertedValue = 279640003; break;
                          case "Crédit Agricole - LCL": convertedValue = 279640004; break;
                          case "Crédit Mutuel - CIC": convertedValue = 279640005; break;
                          case "BNP Paribas": convertedValue = 279640007; break;
                          case "Autres banques": convertedValue = 279640006; break;
                          default: convertedValue = 279640000;
                        }
                        handleChangePlacement(index, 'banque', convertedValue, value);
                      }}
                      mots={["La Banque Postale", "Société Générale", "Crédit Agricole - LCL", "Crédit Mutuel - CIC", "BNP Paribas", "Autres banques"]}
                    />
                  </div>
                  <div className="col-md-6">
                    <InputFieldNbUnique
                      titre="Montant"
                      value={placement.montant}
                      onChange={(value) =>
                        handleChangePlacement(index, 'montant', value, 0)
                      }
                      unit = "€"
                    />
                  </div>
                </div>
                
              </div>
            ))}
          </div>
        </div>

        <div className="row">
          <div className="col-12">
            <button
              type="button"
              className="custom-button"
              onClick={addPlacement}
            >
              Ajouter un Placement
            </button>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-12">
          <Bouton titre="CALCULER" onClick={handleButtonClickAPI}/>
        </div>
      </div>

      {displayBilan && (
        <div>
          <div className="row">
            <div className="col-12">
              {placements.map((placement, index) => (
                <div className="duplique" key={index}>
                  <AppelAPIPlacement
                    index={index}
                    placement={placement}
                    setLancer={setLancer}
                    Lancer={lancer}
                    save={false}
                    setApiResponse={updateApiResponse}
                    setConsoPlacement={updateConsoPlacement}
                  />
                </div>
              ))}
            </div>
          </div>

          <div className="row">
            <div className="col-12">
              <BilanInter
                voyage="non"
                numeroEtape={8}
                responseAPIPlacement={apiResponse}
                listPlacements={placements}
                placement="oui"
              />
            </div>
          </div>

          <div className="row">
            <div className="col-12">
              <Bouton titre="Catégorie suivante" onClick={handleButtonClick}/>
            </div>
          </div>
        </div>
      )}
    </form>
  );
}

export default FormPlacement;
